<template>
    <b-modal id="add-update-doc-type-modal" centered no-close-on-backdrop :footer-class="'d-block p-3 m-0'"
        :body-class="'equipment-edit-modal'" no-close-on-esc>
        <template #modal-header="{ close }">
            <h5 class="modal-title">
                {{ docTypeData ? $t('vaultDocType.updateType') : $t('vaultDocType.addType') }}
            </h5>
            <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>
        <div class="body">
            <b-row>
                <b-col cols="12" class="mt-3">
                    <b-form-group :label="$t('vaultDocType.typeLabel')" class="text-left mb-3">
                        <b-form-input v-model="payload.type" :placeholder="$t('vaultDocType.typePlaceholder')" class="unit" type="text"
                            required></b-form-input>
                        <p v-if="errors && errors.type" class="field-error mb-lg-3">
                            {{ errors.type[0] }}
                        </p>
                    </b-form-group>
                    <div class="text-left mb-0">
                        <label class="state">{{ $t('vaultDocType.notifyExpiry') }}</label>
                        <b-form-checkbox class="ml-0-6rem" v-model="payload.notify_expiry" name="driver-button" switch
                            size="lg" />
                    </div>
                </b-col>
            </b-row>
        </div>
        <template #modal-footer>
            <div class="text-right modal-footer border-0 p-0 mb-0 mt-0">
                <b-button class="mx-0 mr-3 h-40px w-100px m-0" @click="resetForm()" variant="secondary">{{ $t('vaultDocType.cancel') }}</b-button>
                <div class="d-flex align-items m-0">
                    <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary"
                        @click="addAndUpdateDocType()">{{ $t('vaultDocType.save') }}</b-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>
<script>
import { mapActions } from "vuex";
export default {
    name: "AddAndUpdateDocType",
    props: ['docTypeData'],
    data() {
        return {
            payload: {
                type: "",
                notify_expiry: false
            },
            errors: {

            }
        }
    },
    watch: {
        docTypeData: {
            handler(newVal) {
                if (newVal) {
                    this.payload = {
                        type: newVal.type,
                        notify_expiry: newVal.notify_expiry
                    }
                }
            },
            deep: true
        }
    },
    methods: {
        ...mapActions(["setLoader", "setNotification", "addVaultDocTypeRecord", "updateVaultDocTypeRecord"]),
        resetForm() {
            this.payload = {
                type: "",
                notify_expiry: false
            }
            this.errors = {
            }
            this.$emit("reset")
            this.$bvModal.hide('add-update-doc-type-modal')
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async addAndUpdateDocType() {
            try {
                const nullKeys = this.checkNullValues({
                    type: this.payload.type,
                })
                if (nullKeys.length === 0) {
                    this.setLoader(true);
                    if (this.docTypeData) {
                        this.payload.id = this.docTypeData.id
                        await this.updateVaultDocTypeRecord(this.payload);
                    }
                    else await this.addVaultDocTypeRecord(this.payload);
                    await this.setNotification({
                        msg: this.docTypeData ? this.$t('vaultDocType.docTypeUpdated') : this.$t('vaultDocType.docTypeAdded'),
                        type: "success",
                        color: "green",
                    });
                    this.$emit("refreshDocTypes");
                    this.setLoader(false);
                    this.resetForm();
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('vaultDocType.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                this.setLoader(false);
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
            }
        }
    },
}
</script>